import React from "react";
import BioInformationView from "./view";

const BioInformation = () => {
  return <BioInformationView />;
};

export default BioInformation;